import { useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { useGetApplications } from "@/hooks/process";
import ApplicationsList from "@/components/applications/applications-list";

const PendingApplicationsPage = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const {
    data: responseData,
    isLoading,
    isError,
  } = useGetApplications('pending', false, { page, limit: 20, search: search || undefined });

  const data = responseData?.data || [];
  const meta = responseData?.meta;

  const handleSearchChange = useCallback((s: string) => {
    setSearch(s);
    setPage(1);
  }, []);

  return (
    <ApplicationsList
      data={data}
      isLoading={isLoading}
      isError={isError}
      title={t('processManagement.pendingApplications')}
      loadingMessage={t('processManagement.loading')}
      errorMessage={t('processManagement.anErrorOccurredWhileFetchingPendingApplications')}
      searchPlaceholder={t('processManagement.search')}
      baseRoute="/staff/incoming/pending-applications"
      noDataMessage={t('processManagement.noPendingApplicationsFound')}
      meta={meta}
      search={search}
      onSearchChange={handleSearchChange}
      onPageChange={setPage}
    />
  );
};

export default PendingApplicationsPage;
